import { Grid, Tab, Tabs } from '@paintscout/ui'
import React, { useEffect, useState } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import ProductionCalendar, { ProductionCalendarProvider } from 'src/components/common/ProductionCalendar'

export default function SchedulingView() {
  const [tab, setTab] = useState<'calendar' | 'map'>('calendar')
  const location = useLocation()
  const history = useHistory()

  useEffect(() => {
    // Set the tab based on the URL query parameter
    const params = new URLSearchParams(location.search)
    const tabParam = params.get('tab')
    if (tabParam === 'map' || tabParam === 'calendar') {
      setTab(tabParam)
    }
  }, [location.search])

  const handleTabChange = (_: React.ChangeEvent<any>, value: 'calendar' | 'map') => {
    setTab(value)
    history.push(`/scheduling/?tab=${value}`)
  }

  return (
    <ProductionCalendarProvider tab={tab}>
      <Grid container justifyContent="space-between" alignItems="center" spacing={1}>
        <Grid item>
          <Tabs value={tab} onChange={handleTabChange}>
            <Tab label="Calendar" value="calendar" />
            <Tab label="Map" value="map" />
          </Tabs>
        </Grid>

        <Grid item xs={12}>
          <ProductionCalendar />
        </Grid>
      </Grid>
    </ProductionCalendarProvider>
  )
}
